import {Paper, Select, Tabs} from "@mantine/core";
import { House as IconHome, Lock as IconLock, Users as IconUsers } from "@phosphor-icons/react";
import {useEffect, useMemo, useState} from "react";
import withRouteErrorBoundary from "../../../components/ErrorBoundary/withRouteErrorBoundary";
import {Col, Row} from "../../../components/Flex/Flex";
import Label from "../../../components/Label/Label";
import LoaderScreen from "../../../components/Loader/LoaderScreen";
import Page from "../../../components/Page/Page";
import ManageTaverns from "./ManageTaverns";
import ManageAllowlist from "./ManageAllowlist";
import api from "../../../utils/api";
import ViewMembers from "./ViewMembers";


const sortFactions = (a,b) => a.name.localeCompare(b.name);

function ManageNetwork() {
    const [tab, setTab] = useState('taverns');
    const [loading, setLoading] = useState(true);
    const [faction, setFaction] = useState(null);
    const [factions, setFactions] = useState([]);


    useEffect(() => {
        api.get('/bh/manage/factions').then(res => {
            setFactions(res.data.sort(sortFactions));
            if(res.data.length === 1) {
                setFaction(res.data[0].id);
            }
            setLoading(false);
        });
    }, []);


    const selectedFaction = useMemo(() => {
        return factions.find(f => f.id === faction);
    }, [factions, faction]);

    const factionSelectData = useMemo(() => {
        return factions.map(f => ({value: f.id, label: f.name}));
    }, [factions]);


    return (
        <Page>
            <title>Manage Tavern Network</title>
            {loading ? <LoaderScreen message="Checking faction access" /> : null}

            <Paper className="mb-2">
                <Row>
                    <Col>
                        <Label htmlFor="faction-select">Manage Faction: </Label>
                    </Col>
                    <Col>
                        <Select
                            id="faction-select"
                            data={factionSelectData}
                            value={faction}
                            onChange={v => setFaction(v)}
                            searchable={factions.length > 10}
                        />
                    </Col>
                </Row>
                <Tabs value={tab} onChange={setTab}>
                    <Tabs.List>
                        <Tabs.Tab value="taverns" leftSection={<IconHome size={16}/>}>Taverns</Tabs.Tab>
                        <Tabs.Tab value="members" leftSection={<IconUsers size={16}/>}>Members</Tabs.Tab>
                        <Tabs.Tab value="allowlist" leftSection={<IconLock size={16}/>}>Private access</Tabs.Tab>
                    </Tabs.List>
                </Tabs>
            </Paper>
            {selectedFaction ? <>
                {tab === 'overview' ? <span>Overview</span> : null}
                {tab === 'taverns' ? <ManageTaverns faction={selectedFaction} /> : null}
                {tab === 'members' ? <ViewMembers faction={selectedFaction} /> : null}
                {tab === 'allowlist' ? <ManageAllowlist faction={selectedFaction} /> : null}
            </> : null}
        </Page>

    )
}


export default withRouteErrorBoundary(ManageNetwork);
